module.exports = __webpack_public_path__ + "img/tiefgaragendach.c200ded5.webp";